import script from "./DestaqueInicial.vue?vue&type=script&setup=true&lang=js"
export * from "./DestaqueInicial.vue?vue&type=script&setup=true&lang=js"

import "./DestaqueInicial.vue?vue&type=style&index=0&id=2a373a71&scoped=true&lang=css"

import exportComponent from "/home/ewerson/Projetos/vue/vitrine_digital/vitrine-crescimentoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a373a71"]])

export default __exports__